
export default {
  mapboxLoaded: 'mapbox::loaded',
}
